import React from "react";
import verticalSpacing from "helpers/generate-vertical-spacing";
import backgroundColor from "helpers/generate-background";

import Hero from "components/hero";
import RichText from "components/rich-text";
import Process from "components/process";
import Partners from "components/partners";
import FooterCta from "components/footer-cta";
import Faq from "components/faq";
import Testimonials from "components/testimonials";
import BlogFilter from "components/blog-filter";
import SingleTrainer from "components/single-trainer";
import TwoColumns from "components/two-columns";
import VideoSection from "components/video-section";
import HorsesCards from "components/horses-cards";
import Newsletter from "components/newsletter";
import BenefitsClub from "components/benefits-club";
import ComparisonTable from "components/comparison-table";
import OurTrainers from "components/our-trainers";
import BlogHeadlines from "components/blog-headlines";
import ImagesGallery from "components/images-gallery";
import Introduction from "components/introduction";
import RecentNews from "components/recent-news";
import HorseForm from "components/horse-form";
import Benefits from "components/benefits";
import BreedingDetails from "components/breeding-details";
import CtaInfo from "components/cta-info";
import MoreNews from "components/more-news";
import FullpageRichText from "components/fullpage-richText";
import Contact from "components/contact";
import HorseMoreInfo from "components/horse-more-info";
import ShareBreakdown from "components/share-breakdown";
import BundlesCards from "components/bundles-cards";
import Banner from "components/banner";
import Iframe from "components/iframe";
import Events from "components/events";
import Coupons from "components/coupons";
import EventsAndBenefitsSubheading from "components/events-and-benefits-subheading";
import VideoWithNoTitle from "components/video-with-no-title";

const _module2Component = {
  hero: Hero,
  richText: RichText,
  process: Process,
  partners: Partners,
  footerCta: FooterCta,
  faq: Faq,
  testimonials: Testimonials,
  blogFilterSchema: BlogFilter,
  singleTrainer: SingleTrainer,
  twoColumns: TwoColumns,
  videoSection: VideoSection,
  horsesCards: HorsesCards,
  newsletter: Newsletter,
  benefitsClub: BenefitsClub,
  comparisonTable: ComparisonTable,
  ourTrainers: OurTrainers,
  blogHeadlines: BlogHeadlines,
  recentNews: RecentNews,
  imagesGallery: ImagesGallery,
  introduction: Introduction,
  horseForm: HorseForm,
  benefits: Benefits,
  breedingDetails: BreedingDetails,
  ctaInfo: CtaInfo,
  moreNews: MoreNews,
  fullpageRichText: FullpageRichText,
  contact: Contact,
  horseMoreInfo: HorseMoreInfo,
  bundlesCards: BundlesCards,
  shareBreakdown: ShareBreakdown,
  banner: Banner,
  iframe: Iframe,
  events: Events,
  coupons: Coupons,
  eventsAndBenefitsSubheadingBlock: EventsAndBenefitsSubheading,
  videoWithNoTitle: VideoWithNoTitle,
};

const Module = ({ moduleData, type, id, space, background }) => {
  const RequestedModule = _module2Component[type];
  if (RequestedModule)
    return (
      <section
        className={`${space === "none" ? null : verticalSpacing(space)} ${
          background === "none" ? null : backgroundColor(background)
        }`}
        id={id ?? null}
      >
        <RequestedModule data={moduleData} />
      </section>
    );
};

export default Module;
